var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 100,
    viewBox: "0 0 97 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2041_1337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1607 36.6367C27.1607 16.537 41.8115 0.204102 59.9001 0.204102H93.0891V37.137C93.0891 57.2368 78.4383 73.5696 60.3497 73.5696H59.8737C41.8115 73.5696 27.1343 57.2662 27.1343 37.137V36.6073L27.1607 36.6367Z",
    fill: "#FFCEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5957 44.9759H4.23584C2.45227 44.9759 1.64409 43.3229 3.00963 42.4778L45.1371 16.2612C45.295 16.159 45.5365 16.159 45.6945 16.2612L87.8219 42.4778C89.1875 43.3229 88.3793 44.9759 86.5957 44.9759Z",
    stroke: "#00008E",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0532 54.8662V78.7518",
    stroke: "#00008E",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.416 54.8662V78.7518",
    stroke: "#00008E",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5278 54.8662V78.7518",
    stroke: "#00008E",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.251 88.6421H7.79357C7.53705 88.6421 7.3291 88.85 7.3291 89.1064V97.2138C7.3291 97.4702 7.53705 97.6781 7.79357 97.6781H80.251C80.5075 97.6781 80.7154 97.4702 80.7154 97.2138V89.1064C80.7154 88.85 80.5075 88.6421 80.251 88.6421Z",
    stroke: "#00008E",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2041_1337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthIcon);
export default __webpack_public_path__ + "static/media/auth-icon.b6d2c2b8efe80ead821483be258b471f.svg";
export { ForwardRef as ReactComponent };